// Taxonomie groupée Alertes & Rapports (façon captures Boomerang).
// hw:true => nécessite un capteur / matériel non produit en preview (placeholder).

export const ALERT_GROUPS = [
  { group: "Alertes Activités", items: [
    { key: "exces_vitesse", label: "Excès de vitesse", types: ["exces_vitesse"] },
    { key: "exces_routier", label: "Excès (vitesse routière)", types: [], hw: true },
    { key: "ralenti", label: "Marche au ralenti", types: ["ralenti"] },
    { key: "arret", label: "Arrêt", types: ["arret_prolonge"] },
    { key: "odometre", label: "Odomètre", types: [], hw: true },
    { key: "temps_moteur", label: "Temps moteur", types: [], hw: true },
    { key: "batterie", label: "Niveau de la batterie", types: ["batterie"] },
    { key: "temperature", label: "Variation de température", types: [], hw: true },
    { key: "carburant_bas", label: "Niveau carburant bas", types: [], hw: true },
    { key: "carburant_ravito", label: "Carburant — ravitaillement", types: [], hw: true },
    { key: "carburant_vol", label: "Carburant — diminution soudaine", types: [], hw: true },
    { key: "heures_conduite", label: "Heures de conduite", types: [], hw: true },
    { key: "variance_capteur", label: "Variance capteur", types: [], hw: true },
    { key: "seuil_consommable", label: "Seuil de consommable", types: [], hw: true },
  ] },
  { group: "Alertes Productivité", items: [
    { key: "visites_poi", label: "Visites POI", types: ["poi_entree"] },
    { key: "depart_poi", label: "Départ POI", types: ["poi_sortie"] },
    { key: "non_entree_poi", label: "Non-Entrée POI", types: [], hw: true },
    { key: "itineraire", label: "Itinéraire géo-clôture", types: [], hw: true },
    { key: "entree_sortie", label: "Entrée / Sortie zone", types: ["zone_entree", "zone_sortie"] },
    { key: "dates_importantes", label: "Dates importantes", types: [], hw: true },
    { key: "dtc", label: "DTC (diagnostic moteur)", types: ["dtc"] },
  ] },
  { group: "Alertes Sécurité", items: [
    { key: "geo_cloture", label: "Géo-Clôture", types: ["zone_entree", "zone_sortie"] },
    { key: "zone_interdite", label: "Zone interdite", types: [], hw: true },
    { key: "deplacement", label: "Déplacement non autorisé", types: ["demarrage_non_autorise"] },
    { key: "contact", label: "Contact moteur", types: ["contact"] },
    { key: "reseau", label: "Perte réseau / intervalle données", types: ["reseau", "deconnexion"] },
    { key: "geo_virtuelle", label: "Géoclôture virtuelle", types: [], hw: true },
    { key: "intervalle_capteur", label: "Intervalle données capteur", types: [], hw: true },
  ] },
  { group: "Alertes Dispatch", items: [
    { key: "hae", label: "HAE", types: [], hw: true },
    { key: "duree_variance", label: "Durée variance", types: [], hw: true },
    { key: "arrivee_tard", label: "Arrivée / Début tard", types: [], hw: true },
    { key: "non_arrivee", label: "Non-Arrivée / Départ", types: [], hw: true },
    { key: "non_entree_emplacement", label: "Non-Entrée emplacement", types: [], hw: true },
  ] },
  { group: "Alertes Composées", items: [
    { key: "composees", label: "Mes alertes personnalisées", types: ["composee"] },
  ] },
  { group: "Maintenance", items: [
    { key: "maintenance", label: "Maintenance", types: ["maintenance"] },
  ] },
];

// R9 — catalogue réorganisé. Placeholders `hw` (temperature, km_intervalle, zone_interdite) retirés du menu
// (code conservé ailleurs). `schedulable:true` = couverture backend schedule réelle. `period` = mode d'affichage.
export const REPORT_GROUPS = [
  { group: "Pilotage", items: [
    { key: "synthese_alertes", label: "Synthèse des alertes", src: "alertsum", schedulable: true },
  ] },
  { group: "Activité", items: [
    { key: "activite", label: "Rapport d'activité", src: "activity", schedulable: true },
    { key: "kilometrage", label: "Kilométrage", src: "activity" },
    { key: "arret", label: "Arrêts", src: "activity" },
    { key: "ralenti", label: "Marche au ralenti", src: "activity" },
    { key: "exces", label: "Excès de vitesse", src: "activity", schedulable: true },
    { key: "road_speed", label: "Excès de vitesse selon la route", src: "road" },
  ] },
  { group: "Productivité", items: [
    { key: "visites_poi", label: "Visites POI", src: "poivisits" },
    { key: "evenements_zone", label: "Événements de zone", src: "alerts", types: ["zone_entree", "zone_sortie"] },
  ] },
  { group: "Coûts & Maintenance", items: [
    { key: "energy_cost", label: "Énergie / carburant / coûts", src: "energy", schedulable: true },
    { key: "maintenance", label: "Maintenance", src: "alerts", types: ["maintenance"] },
  ] },
  { group: "Technique", items: [
    { key: "can_data", label: "Données CAN", src: "can", period: "snapshot" },
    { key: "reseau", label: "Réseau / communication", src: "alerts", types: ["reseau", "deconnexion"] },
  ] },
  { group: "Éco-conduite", items: [
    { key: "eco_score", label: "Score éco-conduite", src: "eco", period: "monthly" },
  ] },
];

// R5 — colonnes de la SYNTHÈSE par POI du rapport « Visites POI » (data source "poivisits").
// Les durées (secondes) sont formatées à l'affichage ; visits/vehicles restent numériques.
export const POI_VISITS_COLS = [
  ["poi", "POI"], ["category", "Catégorie"], ["visits", "Visites"], ["vehicles", "Véhicules"],
  ["presence_s", "Présence"], ["avg_presence_s", "Présence moy."], ["stopped_s", "Arrêt"],
  ["idle_s", "Ralenti"], ["freq_per_day", "Fréq. (/j)"],
];

export const ENERGY_COLS = [
  ["vehicle", "Véhicule"], ["plate", "Immatriculation"], ["energy_type", "Énergie"],
  ["distance_km", "Distance (km)"], ["consumption_value", "Consommation"], ["consumption_unit", "Unité"],
  ["source", "Source"], ["price", "Prix unitaire"], ["cost_xpf", "Coût"], ["note", "Note"],
];

// Colonnes des rapports d'activité (data source "activity")
export const ACTIVITY_COLS = {
  activite: [["vehicle", "Véhicule"], ["plate", "Immat."], ["distance_km", "Distance (km)"], ["moving_min", "Marche (min)"], ["idle_min", "Ralenti (min)"], ["stop_min", "Arrêt (min)"], ["max_speed", "V. max"], ["first_departure_at", "Heure départ"], ["first_departure_location", "Lieu départ"], ["last_arrival_at", "Heure arrivée"], ["last_arrival_location", "Lieu arrivée"]],
  kilometrage: [["vehicle", "Véhicule"], ["plate", "Immat."], ["distance_km", "Distance (km)"], ["max_speed", "V. max"], ["points", "Points GPS"]],
  arret: [["vehicle", "Véhicule"], ["plate", "Immat."], ["stop_min", "Arrêt (min)"], ["moving_min", "Marche (min)"]],
  ralenti: [["vehicle", "Véhicule"], ["plate", "Immat."], ["idle_min", "Ralenti (min)"], ["moving_min", "Marche (min)"]],
  exces: [["vehicle", "Véhicule"], ["plate", "Immat."], ["speeding_events", "Événements"], ["max_speed", "V. max"]],
};

// Colonnes de SYNTHÈSE par véhicule du rapport « Excès de vitesse selon la route » (data source "road").
// coverage.* est aplati dans ReportsPage (cov_*). Les états unknown/ambiguous/unsupported NE sont jamais des excès.
export const ROAD_SPEED_COLS = [
  ["vehicle", "Véhicule"], ["plate", "Immat."], ["episodes", "Épisodes"], ["max_excess", "Dépass. max (km/h)"],
  ["cov_points", "Points analysés"], ["cov_matched", "Rattachés"], ["cov_known_limit", "Limite connue"],
  ["cov_unknown", "Inconnu"], ["cov_ambiguous", "Ambigu"], ["cov_unsupported", "Non pris en charge"],
];
